import isEqual from 'lodash.isequal'
import { Product, ProductRowFields } from 'types'

export const getProductRowChanges = (
  original: Product[],
  current: Product[]
): { tableName: string; PK: string; SK: string; fieldName: string; newValue: any }[] => {
  const updates: any[] = []

  const editableFields: (keyof ProductRowFields)[] = [
    'price',
    'billedPrice',
    'margin',
    'mediaSpend',
    'status',
    'dateRange',
    'startDate',
    'endDate',
    'payer',
    'accountUsed',
  ]

  current.forEach(currProduct => {
    const originalProduct = original.find(p => p.SK === currProduct.SK)

    if (!originalProduct) {
      // New row entirely — send full data for all fields
      editableFields.forEach(field => {
        updates.push({
          tableName: 'ORGANIZATIONS_TABLE',
          PK: currProduct.PK,
          SK: currProduct.SK,
          fieldName: field,
          newValue: currProduct[field],
        })
      })
    } else {
      editableFields.forEach(field => {
        const orig = originalProduct[field]
        const curr = currProduct[field]
        if (!isEqual(orig, curr)) {
          updates.push({
            tableName: 'ORGANIZATIONS_TABLE',
            PK: currProduct.PK,
            SK: currProduct.SK,
            fieldName: field,
            newValue: curr,
          })
        }
      })
    }
  })

  return updates
}
export const getProductBatchReplaceItems = (
  original: Product[],
  current: Product[]
): {
  tableName: string
  PK: string
  SK: string
  newItem: Product
}[] => {
  const updated: any[] = []

  const editableFields: (keyof ProductRowFields)[] = [
    'price',
    'billedPrice',
    'margin',
    'mediaSpend',
    'status',
    'dateRange',
    'startDate',
    'endDate',
    'payer',
    'accountUsed',
    'landingPageUrl',
    'marketingObjective',
    'geoLocationType',
    'geoLocationName',
    'audience',
    'creativeSuppliedBy',
    'copySuppliedBy',
    'searchTargetingSpecifics',
    'searchPlatform',
    'socialPlatform',
    'socialTargetingSpecifics',
    'audienceTargeting',
    'displayPlatform',
    'cmsLoginUsername',
    'cmsLoginPassword',
    'cmsLoginUrl',
    'websiteUrl',
  ]

  current.forEach(curr => {
    const orig = original.find(p => p.SK === curr.SK)

    if (!orig) {
      // New row — send whole item
      updated.push({
        tableName: 'ORGANIZATIONS_TABLE',
        PK: curr.PK,
        SK: curr.SK,
        newItem: { ...curr },
      })
    } else {
      const changed = editableFields.some(field => !isEqual(orig[field], curr[field]))
      if (changed) {
        updated.push({
          tableName: 'ORGANIZATIONS_TABLE',
          PK: curr.PK,
          SK: curr.SK,
          newItem: { ...curr },
        })
      }
    }
  })

  return updated
}
